<div class="container small-bottom-margin">

  <div>Welcome to the discount code management page. Here, you can add, edit, and delete discount codes. Use the "Add
    Discount Code" button to create a new code, or click "Edit" next to an existing code to modify its details. To
    remove
    a code, simply click the "Delete" button and confirm your action. The table below displays all existing discount
    codes
    along with their effective dates, descriptions, and applicable member groups. You can sort the table by clicking on
    the dates. <strong>Please note that these discount codes must be set up in Protech as well.</strong></div>

  <button class="btn btn--solid btn--red btn--small small-bottom-margin" (click)="openAddDialog()">Add Discount
    Code</button>

  <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" matSort matSortActive="effectiveBeginDate"
    matSortDisableClear matSortDirection="desc">
    <!-- Position Column -->
    <ng-container matColumnDef="marketCode">
      <th mat-header-cell *matHeaderCellDef> Market Code </th>
      <td mat-cell *matCellDef="let element"> {{element.marketCode}} </td>
    </ng-container>

    <!-- Name Column -->
    <ng-container matColumnDef="effectiveBeginDate">
      <th mat-header-cell mat-sort-header *matHeaderCellDef> Begin Date </th>
      <td mat-cell *matCellDef="let element"> {{element.effectiveBeginDate | date : 'yyyy-MM-dd'}} </td>
    </ng-container>

    <!-- Weight Column -->
    <ng-container matColumnDef="effectiveEndDate">
      <th mat-header-cell mat-sort-header *matHeaderCellDef> End Date </th>
      <td mat-cell *matCellDef="let element"> {{element.effectiveEndDate | date : "yyyy-MM-dd"}} </td>
    </ng-container>

    <!-- Symbol Column -->
    <ng-container matColumnDef="description">
      <th mat-header-cell *matHeaderCellDef> Description </th>
      <td mat-cell *matCellDef="let element"> {{element.description}} </td>
    </ng-container>

    <ng-container matColumnDef="flatDiscount">
      <th mat-header-cell *matHeaderCellDef> Flat Discount </th>
      <td mat-cell *matCellDef="let element"> {{element.flatDiscount}} </td>
    </ng-container>

    <ng-container matColumnDef="discountPercent">
      <th mat-header-cell *matHeaderCellDef> Discount Percent </th>
      <td mat-cell *matCellDef="let element"> {{element.discountPercent}} </td>
    </ng-container>

    <ng-container matColumnDef="memberGroups">
      <th mat-header-cell *matHeaderCellDef> Member Groups </th>
      <td mat-cell *matCellDef="let element"> {{element.memberGroups}} </td>
    </ng-container>

    <ng-container matColumnDef="editButton">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <button class="btn btn--solid btn--red btn--small small-bottom-margin"
          (click)="openEditDialog(element)">Edit</button>
      </td>
    </ng-container>

    <ng-container matColumnDef="deleteButton">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <button class="btn btn--solid btn--red btn--small small-bottom-margin"
          (click)="openConfirmAlert(element)">Delete</button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
</div>
<app-aaos-spinner [isLoading]="loading"></app-aaos-spinner>
